import { render, staticRenderFns } from "./Dashboard-Admin.vue?vue&type=template&id=59f17929&scoped=true"
import script from "./Dashboard-Admin.js?vue&type=script&lang=js&external"
export * from "./Dashboard-Admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f17929",
  null
  
)

export default component.exports